export default {
  headers: {
    edit_time: 'Editar horario',
    create_time: 'Crear horario',
  },
  labels: {
    select_all: 'Seleccionar todo',
  },
  buttons: {
    add_opening_time: 'Agregar horario de apertura',
    add: 'Agregar',
    cancel: 'Cancelar',
  },
};
